import React from "react";
import "../App.css";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";

import About from "../containers/About/About";
import Reasons from "../containers/AppReasons/Reasons";
import Hero from "../containers/Hero/Hero";
import How from "../containers/How/How";
import JoinUs from "../containers/Join Us/JoinUs";

const HomePage = () => {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Reasons />
      <JoinUs />
      <How />
      <Footer />
    </div>
  );
};

export default HomePage;
